import React, { useEffect, useRef, useState } from "react";
import "./SpinWheel.css";
import spinAudio from "./spin-wheel-1.mp3";
import arrow from "./arrow-icon.png";
import coin1 from "./1.png";
import coin2 from "./2.png";
import coin3 from "./3.png";
import coin4 from "./4.png";
import coin5 from "./5.png";
import coin6 from "./6.png";
import { apiGet, apiPost } from "../../Utils/apiFetch";
import apiPath from "../../Utils/apiPath";
const SpinWheel = (props) => {
  const canvasRef = useRef(null);
  const [angVel, setAngVel] = useState(0);
  const [ang, setAng] = useState(0);
  const [spinning, setSpinning] = useState(false);
  const [soundEnabled, setSoundEnabled] = useState(false);
  const [winner, setWinner] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalMessage, setModalMessage] = useState("");
  const [winnerList, setWinnerList] = useState([]);
  const [predefinedWinner, setPredefinedWinner] = useState(10); // Default to 10
  const [spinSpeed, setSpinSpeed] = useState(0.6); // Fixed speed for controlled spin
  const [totalSpin, setTotalSpin] = useState(2); // Fixed speed for controlled spin

  const spinSound = useRef(new Audio(spinAudio));

  const sectors = [
    { color: "", text: "#fff", label: "1", number: 1 },
    { color: "", text: "#fff", label: "2", number: 2 },
    { color: "", text: "#fff", label: "3", number: 3 },
    { color: "", text: "#fff", label: "4", number: 4 },
    { color: "", text: "#fff", label: "5", number: 5 },
    { color: "", text: "#fff", label: "6", number: 6 },
    { color: "", text: "#fff", label: "7", number: 7 },
    { color: "", text: "#fff", label: "8", number: 8 },
    { color: "", text: "#fff", label: "9", number: 9 },
    { color: "", text: "#fff", label: "10", number: 10 },
    { color: "", text: "#fff", label: "11", number: 11 },
    { color: "", text: "#fff", label: "12", number: 12 },
    { color: "", text: "#fff", label: "13", number: 13 },
    { color: "", text: "#fff", label: "14", number: 14 },
    { color: "", text: "#fff", label: "15", number: 15 },
    { color: "", text: "#fff", label: "50", number: 16 },
    { color: "", text: "#fff", label: "100", number: 17 },
    { color: "", text: "#fff", label: "150", number: 18 },
  ];

  const drawWheel = () => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    const arc = (2 * Math.PI) / sectors.length;
    const rad = canvas.width / 2;
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    sectors.forEach((sector, i) => {
      const angle = arc * i;
      ctx.save();
      ctx.beginPath();
      ctx.fillStyle = sector.color;
      ctx.moveTo(rad, rad);
      ctx.arc(rad, rad, rad, angle, angle + arc);
      ctx.lineTo(rad, rad);
      ctx.fill();
      // Add border
      ctx.strokeStyle = sector.borderColor || "#ffcf00"; // default to black if not defined
      ctx.lineWidth = 2; // you can adjust the thickness here
      ctx.stroke();
      ctx.translate(rad, rad);
      ctx.rotate(angle + arc / 2);
      ctx.textAlign = "right";
      ctx.fillStyle = sector.text;
      ctx.font = "normal 25px 'Impact','Comic Sans MS', cursive, sans-serif";
      ctx.fillText(sector.label, rad - 20, 10);
      ctx.restore();
    });
    rotateWheel();
  };

  const rotateWheel = (ang) => {
    const canvas = canvasRef.current;
    if (canvas) {
      canvas.style.transform = `rotate(${ang - Math.PI / 2}rad)`;
    }
  };

  // ** Control Variables (Modify Here) **

  const spinWheel = async () => {
    if (spinning) return;

    const { status, data } = await apiGet(apiPath.checkSpin);
    if (status !== 200 || !data?.success) {
      return showSuccessMessage("WARNING ALERT", data?.message);
    }

    let targetPredefinedWinner = sectors?.find(
      (res) => res.label == data.results.winAmount
    )?.number;
    if (!targetPredefinedWinner) return;

    const index = targetPredefinedWinner - 1; // 0-based index
    setPredefinedWinner(targetPredefinedWinner);
    setWinner(null);
    setSpinning(true);

    const TAU = 2 * Math.PI;
    const anglePerSector = TAU / sectors.length;
    const offset = anglePerSector / 2;

    // Final angle to stop at (clockwise from top, so invert index)
    const targetAngle = (sectors.length - index) * anglePerSector - offset;

    const currentAng = ang % TAU;
    const fullSpins = 6;
    const finalAngle =
      currentAng + TAU * fullSpins + ((targetAngle - currentAng + TAU) % TAU);

    const duration = 6000;
    const startTime = performance.now();

    const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);

    const animate = (now) => {
      const elapsed = now - startTime;
      const t = Math.min(elapsed / duration, 1);
      const eased = easeOutCubic(t);
      const current = currentAng + (finalAngle - currentAng) * eased;

      setAng(current);
      rotateWheel(current);

      if (t < 1) {
        requestAnimationFrame(animate);
      } else {
        setAng(finalAngle % TAU); // Ensure it's aligned at end
        rotateWheel(finalAngle % TAU);
        setSpinning(false);
        onSpinEnd(index);
      }
    };

    requestAnimationFrame(animate);

    if (soundEnabled) {
      spinSound.current.currentTime = 0;
      spinSound.current
        .play()
        .catch((error) => console.error("Audio play error:", error));
    }
  };

  const onSpinEnd = async (index) => {
    if (index < 0 || index >= sectors.length) {
      console.error("Invalid index passed to onSpinEnd:", index);
      return;
    }

    const finalSector = sectors[index];
    if (!finalSector) {
      console.error("Sector not found at index:", index);
      return;
    }

    try {
      const { status, data } = await apiPost(apiPath.updateSpin);
      if (status === 200 && data?.success) {
        console.log(" Cal : ", index);
        setWinner(finalSector.label);

        setWinnerList((prev) => {
          const updatedList = [...prev, finalSector.label];
          localStorage.setItem("winner", JSON.stringify(updatedList)); // Save to localStorage
          return updatedList;
        });

        setTotalSpin((prevSpin) => parseInt(prevSpin) - 1);
        showSuccessMessage(
          "Congratulations!",
          `Woop! You won ${finalSector.label}`
        );
      } else {
        showSuccessMessage("ERROR", data?.message || "Something went wrong");
      }

      spinSound.current.pause();
    } catch (error) {
      console.error("Error in onSpinEnd:", error);
    }
  };

  useEffect(() => {
    drawWheel();
    // localStorage.clear();
    const PI = Math.PI;
    const TAU = 2 * PI;
    const targetAngle = TAU - (predefinedWinner / sectors.length) * TAU + 0.25;
    setAng(targetAngle);
  }, [predefinedWinner]);

  useEffect(() => {
    if (!spinning) return;
    const frame = () => {
      setAng((prevAng) => (prevAng + angVel) % (2 * Math.PI));
      setAngVel((prevVel) => prevVel * 0.992);
      if (angVel < 0.002) {
        setAngVel(0);
        setSpinning(false);
        onSpinEnd();
      }
      rotateWheel(ang);
    };
    const animation = requestAnimationFrame(frame);
    return () => cancelAnimationFrame(animation);
  }, [ang, angVel, spinning]);

  const showSuccessMessage = (title, message) => {
    setModalTitle(title);
    setModalMessage(message);
    if (title === "ALL RESULTS") {
      const winners = JSON.parse(localStorage.getItem("winner")) || [];
      setWinnerList(winners);
    }
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const openPopUp = () => {
    showSuccessMessage(
      "ALL RESULTS",
      "This section shows all the results selected during the current visit."
    );
  };

  useEffect(() => {
    spinSound.current.muted = !soundEnabled; // Keep it muted initially
    spinSound.current.preload = "auto"; // Preload to avoid delays
  }, [soundEnabled]);

  return (
    <div className="container-main">
      <div class="roulette_main_coin">
        <span class="roulette_main_coinWrap">
          {" "}
          <img src={coin1} class="roulette_main_coin_1" />
        </span>
        <span class="roulette_main_coinWrap">
          <img src={coin3} class="roulette_main_coin_2" />
        </span>
        <span class="roulette_main_coinWrap">
          <img src={coin2} class="roulette_main_coin_3" />
        </span>
        <span class="roulette_main_coinWrap">
          <img src={coin4} class="roulette_main_coin_4" />
        </span>
        <span class="roulette_main_coinWrap">
          <img src={coin5} class="roulette_main_coin_5" />
        </span>
        <span class="roulette_main_coinWrap">
          <img src={coin6} alt="krikya-exchange" class="roulette_main_coin_6" />
        </span>
      </div>
      <div style={{ position: "relative" }} className="spin-custom-css">
        <span className="down-arrow">
          <img src={arrow} alt="Arrow" style={{ width: 43 }} />
        </span>
        <div id="spin_the_wheel">
          <canvas ref={canvasRef} width={400} height={400} />
          <div id="spin"></div>
        </div>
      </div>
      <div className="sound-icon-container">
        <button
          id="sound-toggle"
          onClick={() => setSoundEnabled((prev) => !prev)}
        >
          {soundEnabled ? "🔊" : "🔇"}
        </button>
      </div>
      <div className="play-btn-container">
        <button
          id="play"
          className="btn"
          onClick={() => {
            console.log("totalSpin : ", totalSpin);
            // if (totalSpin > 0) {
            spinWheel();
            // } else {
            //   showSuccessMessage(
            //     "WARNING ALERT",
            //     "You don't have sufficient spin"
            //   );
            // }
          }}
          disabled={spinning}
        >
          ▶️ Play
        </button>
      </div>
      <div className="trophy-container" onClick={openPopUp}>
        <button id="trophy-button">🏆</button>
      </div>

      {showModal && (
        <div id="success-modal" className="modal">
          <div className="modal-content won-style">
            <span className="close-button" onClick={closeModal}>
              &times;
            </span>
            <h2 id="modal-title">{modalTitle}</h2>
            <p id="modal-message">{modalMessage}</p>
            {modalTitle === "ALL RESULTS" && winnerList.length > 0 ? (
              <ul id="winner-list">
                {winnerList.map((win, index) => (
                  <li key={index}>
                    {index + 1}: {win}
                  </li>
                ))}
              </ul>
            ) : null}
            <button className="won-button" onClick={closeModal}>
              OK
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default SpinWheel;
